import { PayloadAction, createSlice } from "@reduxjs/toolkit";

import { RootState } from "../Store";

interface IModalState {
	componentName: string;
	show?: boolean;
	title?: string;
}

const initialState: IModalState = {
	componentName: "",
	show: false,
	title: ""
};

const HintModalSlice = createSlice({
	name: "HintModalSlice",
	initialState,
	reducers: {
		showHintModal: (state, action: PayloadAction<IModalState>) => {
			state.show = true;
			state.componentName = action.payload?.componentName;
			state.title = action.payload?.title || "";
		},
		hideHintModal: (state) => {
			state.show = false;
			state.componentName = "";
			state.title = "";
		}
	}
});

export const { showHintModal, hideHintModal } = HintModalSlice.actions;

export const hintModalSelector = (rootState: RootState) => rootState.hintModalReducer;

export default HintModalSlice.reducer;
